import {
  Card,
  MantineGradient,
  Stack,
  Text,
  createStyles,
  getStylesRef,
  keyframes,
  useMantineTheme,
} from '@mantine/core'
import React from 'react'
import { LazyImage } from 'src/components/common/LazyImage'
import { transitionStyles } from 'src/styles'

export const bounce = keyframes({
  // smooth scale up and down animation
  '0%': {
    transform: 'scale(1)',
  },
  '50%': {
    transform: 'scale(1.1)',
  },
  '100%': {
    transform: 'scale(1)',
  },
})

const useStyles = createStyles(theme => ({
  cardWrapper: {
    height: 340,
    maxWidth: 300,
    borderRadius: '45px',

    background: '#451599',
    border: `1px solid #451599`,
    boxShadow: 'inset 20px 20px 60px #290d5c,inset -20px -20px 60px #611dd6',
    transition: transitionStyles.themeChange,

    // scale on hover
    '&:hover': {
      // borderRadius: '20px',
      transform: 'scale(1.1)',
      transition: transitionStyles.themeChange,
      border: `1px solid ${theme.colors.gray[5]}`,
    },

    [`&:hover .${getStylesRef('imageStyle')}`]: {
      animation: 'none',
      transform: 'scale(1.7)',
      transition: transitionStyles.themeChange,
    },
  },
  imageStyle: {
    ref: getStylesRef('imageStyle'),
    transition: transitionStyles.themeChange,
    // continous animation up and down on hover
    animation: `${bounce} 1.5s ease-in-out infinite`,
  },
}))

export interface AboutMeCardProps {
  name: string
  description: string
  image: string
  gradient?: MantineGradient
}

export const AboutMeCard: React.FC<AboutMeCardProps> = props => {
  const { name, description, image } = props
  const { classes } = useStyles()
  const { colors } = useMantineTheme()

  return (
    <Card className={classes.cardWrapper} shadow="xl">
      <Stack justify="flex-start" align="center" h={'inherit'} p={'md'}>
        <LazyImage src={image} className={classes.imageStyle} style={{ height: 90, width: 90 }} />
        <Stack>
          <Text size={'xl'} weight={600} color={colors.gray[3]}>
            {name}
          </Text>
          <Text size={'md'} mt={'sm'} color={colors.gray[3]}>
            {description}
          </Text>
        </Stack>
      </Stack>
    </Card>
  )
}
